import React from 'react'
import { css } from '@emotion/core'
import { DescriptionTooltip, colors } from '@fs/zion-ui'
import type { TempleRollupStatus } from '@fs/zion-tree-types'
import { NoticeLoading } from '@fs/zion-icon'
import TempleIcon from './TempleIcon'

const alignmentCss = css`
  top: 10px;
  width: 32px;
  height: 31px;
  inset-inline-end: 8px;
  position: relative;
`
const loadingAlignmentCss = css`
  position: relative;
  inset-inline-end: 8px;
`

export default function OrdinanceBadge({
  status,
  label,
}: {
  status?: TempleRollupStatus
  label?: string
}): JSX.Element {
  let color
  let background
  let style
  let loading = false
  switch (status) {
    case 'READY':
    case 'RESERVED_SHARED_READY':
      color = colors.gray00
      background = colors.green30
      break
    case 'RESERVED':
      color = colors.gray00
      background = colors.blue60
      break
    case 'NEEDS_MORE_INFORMATION':
      color = colors.yellow90
      background = colors.yellow10
      break
    case 'COMPLETED':
      color = colors.gray90
      background = colors.gray10
      break
    case 'NOT_AVAILABLE':
      color = colors.gray90
      background = 'none'
      style = { border: `1px dashed ${colors.gray100}` }
      break
    case 'CALCULATING':
    default:
      loading = true
      break
  }

  return (
    <DescriptionTooltip
      target={
        <>
          {loading ? (
            <div css={loadingAlignmentCss}>
              <NoticeLoading size="xs" color="gray" />
            </div>
          ) : (
            <div css={alignmentCss}>
              <TempleIcon
                style={style}
                color={color}
                background={background}
                hasTimer={status === 'RESERVED_SHARED_READY'}
              />
            </div>
          )}
        </>
      }
      label={label}
    />
  )
}
